import { render, staticRenderFns } from "./EventFormSettingPage.vue?vue&type=template&id=433626ac"
import script from "./EventFormSettingPage.vue?vue&type=script&lang=js"
export * from "./EventFormSettingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports